export default "__VITE_ASSET__BJK9Vc0K__"